// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // PlanLinkConnectedProps,
  PlanLinkMapStateReturnType,
} from './types'

export const PlanLinkMapState = (): // state: StateReducers,
// props: PlanLinkConnectedProps,
PlanLinkMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
